import { render } from "./NcesIdTool.vue?vue&type=template&id=6cc1ba98&scoped=true"
import script from "./NcesIdTool.vue?vue&type=script&lang=js"
export * from "./NcesIdTool.vue?vue&type=script&lang=js"

import "./NcesIdTool.vue?vue&type=style&index=0&id=6cc1ba98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc1ba98"]])

export default __exports__